<template>
    <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12>
        <v-card class="app-card">
          <v-card-title class="app-card-title mb-0">
            <h4 class="text">
              Detalhes do Pedido               
            </h4>

            <v-spacer></v-spacer>
              <h4 class="text" v-if="order"> Número:{{ order.id }}</h4>
          </v-card-title>
          <v-card-text class="app-card-content">            
            <OrderDetailHeader 
              v-if="order"
              :order="order" 
            />

            <OrderDetailTabs 
              v-if="order"
              :order="order" 
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import OrderDetailHeader from './components/OrderDetailHeader.vue';
import OrderDetailTabs from './components/OrderDetailTabs.vue';

export default {
  name: "OrderDetail",

  components: {
    OrderDetailHeader,
    OrderDetailTabs
  },

  data: () => ({}),

  mounted() {
    this.fetchOrder();
  },

  destroyed() {
    this.clear();
  },

  watch: {
    '$route.params.id'(newId, oldId) {      
      this.fetchOrder()
    }
  },

  computed: {
    ...mapState('order', { order: state => state.detail.data })
  },

  methods: {
    fetchOrder() {
      if (!this.$route.params.id) return;

      this.fetch(this.$route.params.id);
    },

    ...mapActions('order', { 
      fetch: 'SHOW', 
      clear: 'CLEAR_DETAIL',      
    }),
  },
};
</script>

<style lang="scss" scoped>
.isLoading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  margin: 0px;
}
</style>
